// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Table(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Table" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.5 20.5V3.5H21.5V20.5H2.5ZM13 5.5H19.5V8.5H13V5.5ZM11 5.5H4.5V8.5H11V5.5ZM11 10.5H4.5V13.5H11V10.5ZM11 15.5H4.5V18.5H11V15.5ZM13 18.5V15.5H19.5V18.5H13ZM13 13.5V10.5H19.5V13.5H13Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Table.js.map